<template>
  <div class="flex flex-col h-screen">
    <header
      class="z-10 flex items-center justify-between px-6 py-4 bg-blue-900 border-b dark:bg-gray-900 dark:border-gray-700"
    >
      <title>{{ section }} - StaffAdmin</title>
      <div class="flex items-center">
        <button class="mr-6 focus:outline-none md:hidden" @click="sidebarOpen = true">
          <i-heroicons-outline-menu class="text-2xl" />
        </button>
        <!-- <button
          v-if="darkMode"
          class="mr-6 focus:outline-none"
          @click="$emit('update:darkMode', false)"
        >
          <i-heroicons-outline-sun class="text-2xl" />
        </button>
        <button v-else class="mr-6 focus:outline-none" @click="$emit('update:darkMode', true)">
          <i-heroicons-outline-moon class="text-2xl" />
        </button> -->
        <router-link to="/staff">
          <img src="/AKLogoCropClear.png" alt="logo" height="46" width="194" />
        </router-link>
      </div>

      <div class="flex-1">
        <div class="flex items-center justify-end space-x-6">
          <div class="relative">
            <!-- <button
              v-if="notificationUnread"
              class="flex text-gray-600 focus:outline-none"
              @click="notificationDropdownOpen = !notificationDropdownOpen"
            >
              <i-heroicons-outline-bell class="text-2xl text-gray-200" />
              <span
                v-if="notificationUnread"
                class="absolute w-4 h-4 overflow-hidden text-xs text-center text-white rounded-lg -top-1 -right-1"
                >{{ notificationUnread > 9 ? "+" : notificationUnread }}</span
              >
            </button> 

            <router-link v-else to="notifications" class="flex text-gray-600 focus:outline-none">
              <i-heroicons-outline-bell class="text-2xl text-gray-300" />
            </router-link>-->

            <div
              v-show="notificationDropdownOpen"
              class="fixed inset-0 z-10 w-full h-full"
              @click="notificationDropdownOpen = false"
            ></div>
            <div
              v-show="notificationDropdownOpen"
              class="absolute right-0 z-10 mt-2 overflow-hidden bg-white border rounded-lg shadow-xl dark:bg-gray-800 dark:border-gray-900 w-80"
            >
              <ul
                v-if="notifications.length > 0"
                @click="notificationDropdownOpen = !notificationDropdownOpen"
              >
                <li v-for="{ id, message, timestamp } in notifications" :key="id">
                  <router-link
                    :to="`/admin/notification-detail/${id}`"
                    class="flex items-center px-4 py-3 -mx-2 hover:text-white hover:bg-blue-600"
                  >
                    <p class="mx-2 text-sm">
                      {{ message }} <span class="font-bold">·</span>
                      {{ fromAgo(timestamp) }}
                    </p>
                  </router-link>
                </li>
              </ul>
              <div v-else class="px-4 py-3 italic text-center text-gray-400">Empty</div>
            </div>
          </div>

          <div class="text-gray-300 cursor-pointer" @click="toggleStaffNote">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="w-8 h-8"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"
              />
            </svg>
          </div>
          <div class="relative">
            <button
              class="relative block w-8 h-8 overflow-hidden focus:outline-none"
              @click="accountDropdownOpen = !accountDropdownOpen"
            >
              <i-heroicons-outline-user class="text-2xl text-gray-300" />
            </button>

            <div
              v-show="accountDropdownOpen"
              class="fixed inset-0 z-10 w-full h-full"
              @click="accountDropdownOpen = false"
            ></div>
            <nav
              v-show="accountDropdownOpen"
              class="absolute right-0 z-10 w-48 mt-2 overflow-hidden bg-white border rounded-md shadow-xl dark:bg-gray-800 dark:border-gray-900"
              @click="accountDropdownOpen = !accountDropdownOpen"
            >
              <router-link
                to="/staff/profile"
                class="block px-4 py-2 text-sm hover:bg-blue-600 hover:text-white"
              >
                Profile
              </router-link>
              <a
                class="block px-4 py-2 text-sm hover:bg-blue-600 hover:text-white"
                @click="handleClickLogout"
              >
                Logout
              </a>
            </nav>
          </div>
        </div>
      </div>
    </header>
    <main class="flex flex-grow">
      <!-- <div class="flex h-screen text-gray-700 bg-gray-100 dark:bg-gray-900 dark:text-gray-200"> -->
      <!-- sidebar mobile mask -->
      <div
        :class="sidebarOpen ? 'block' : 'hidden'"
        class="fixed inset-0 z-10 transition-opacity bg-black opacity-50 md:hidden"
        @click="sidebarOpen = false"
      ></div>

      <!-- sidebar -->
      <aside
        v-if="isLoggedIn"
        :class="sidebarOpen ? 'translate-x-0 ease-out' : '-translate-x-full ease-in'"
        class="fixed inset-y-0 left-0 z-10 flex flex-col w-[17em] p-4 overflow-y-auto transition duration-150 transform bg-white border-r dark:bg-gray-800 dark:border-gray-700 md:translate-x-0 md:static md:inset-0"
      >
        <button
          @click="sidebarOpen = false"
          class="flex flex-row items-center w-auto px-8 py-3 bg-gray-100 rounded md:hidden md:"
        >
          <i-heroicons-outline-arrow-left class="text-2xl text-gray-700" />
          <span class="ml-8 text-lg text-gray-700">Hide </span>
        </button>
        <h2 class="mt-8 mb-6 text-lg font-bold md:hidden">AK Admin</h2>

        <div v-for="section in menuItems">
          <div class="mt-2 font-bold text-gray-700">{{ section.sectionName }}</div>
          <div v-for="link in section.links" :key="link.name" class="px-6 py-2 bg-white">
            <router-link
              :class="{ 'font-bold bg-blue-50': link.name === props.section }"
              class="px-4 py-1 text-blue-900 hover:bg-blue-50"
              :to="link.to"
              >{{ link.name }}</router-link
            >
          </div>
        </div>
      </aside>

      <main class="flex flex-col flex-1 overflow-hidden">
        <main class="flex-1 px-8 py-6 overflow-x-hidden overflow-y-auto">
          <h1 v-if="showHeader" class="py-3 mb-4 text-xl border-b flex w-full">
            <div class="font-bold grow">{{ section }}</div>
          </h1>
          <slot></slot>
        </main>
      </main>

      <!-- staffnote sidebar-->
      <aside
        v-if="isStaffNoteOpen"
        :class="isStaffNoteOpen ? '-translate-x-0 ease-in' : 'translate-x-full ease-out'"
        class="sticky h-full right-0 top-0 w-[25em] p-4 border-l bg-white transition duration-150 transform"
        :style="{ height: noteSidebarHeight }"
      >
        <div v-if="staffNote" class="flex flex-col h-full gap-4">
          <div class="grow">
            <h1 class="text-lg border-b">{{ staffNote.page }}</h1>
            <p v-show="!isEditingStaffNote" class="richText" v-html="staffNote.note" />

            <div
              class="h-full richText border border-black border-x"
              v-if="isEditingStaffNote"
            >
              <div id="ckedit container" v-if="Ckeditor && Editor">
                <!-- Begin CKEditor component -->
                <component :is="Ckeditor" :editor="Editor" v-model="editedNote" />
                <!-- End CKEditor component -->
              </div>
              <div v-else>
                <p class="italic text-gray-400">Loading editor...</p>
              </div>
            </div>
          </div>
          <div class="sticky mt-10 w-full">
            <div v-if="isEditingStaffNote" class="flex gap-4">
              <BaseButton @click="cancelEditingStaffNote" class="w-1/2">
                Cancel
              </BaseButton>
              <BaseButton @click="saveStaffNote" class="w-1/2"> Save </BaseButton>
            </div>
            <BaseButton
              v-if="!isEditingStaffNote"
              @click="editStaffNote"
              class="ml-auto right-0 w-1/2"
            >
              Edit
            </BaseButton>
          </div>
        </div>
      </aside>
    </main>
    <footer class="p-4 bg-gray-200">
      <div class="flex flex-row">
        <div class="flex-grow font-serif text-sm text-gray-800">
          Copyright &copy; AK Preparedness, LLC {{ new Date().getFullYear() }}
        </div>
        <div class="px-4 pt-1 font-mono text-sm text-gray-800 bg-gray-300">
          {{ version }}
        </div>
      </div>
    </footer>
  </div>
</template>

<script setup lang="ts">
import { fromAgo } from "../helpers";

import { useUserStore } from "../store/userStore";
import { useAdminStore } from "../store/adminStore";
import { useAlertStore } from "../store/alertStore";
import { useBldgStore } from "../store/bldgStore";
import { usePersonStore } from "../store/personStore";
import { useRespondStore } from "../store/respondStore";
import { useTrainingStore } from "../store/trainingStore";
import { useReportStore } from "../store/reportStore";

// CKEditor dynamic imports - load at runtime to properly handle UMD
import { useRouter } from "vue-router";
import { SaveStaffNoteRequest, StaffNoteDTO } from "../store/generatedFetchClient";
import { useCKEditor } from "../composables/useCKEditor";

// Load CKEditor using composable
const { Ckeditor, Editor } = useCKEditor();

const userStore = useUserStore();
const adminStore = useAdminStore();
const alertStore = useAlertStore();
const bldgStore = useBldgStore();
const personStore = usePersonStore();
const respondStore = useRespondStore();
const trainingStore = useTrainingStore();
const reportStore = useReportStore();

const router = useRouter();
//const route = useRoute();

// Load & initialize component
onMounted(async () => {
  // Initialize user and staff note
  await userStore.getStaffUser();
  afterLogin();

  if (isStaffNoteOpen.value)
    staffNote.value = await adminStore.getStaffNote(cleanedPath.value);
});

const isLoggedIn = computed(() => userStore.isStaffUser);
watch(isLoggedIn, () => afterLogin());

// Do these things after we detect a succssful login
async function afterLogin() {
  if (isLoggedIn.value) {
    if (!adminStore.staffUserSetupAfterLogin) {
      console.log("Staff layout detected user login");
      adminStore.staffUserSetupAfterLogin = true;
      let token = userStore.authToken;

      if (token) {
        adminStore.setAuthToken(token);
        alertStore.setAuthToken(token);
        bldgStore.setAuthToken(token);
        personStore.setAuthToken(token);
        respondStore.setAuthToken(token);
        trainingStore.setAuthToken(token);
        reportStore.setAuthToken(token);

        await adminStore.getCounts();
      }
    }
  } else {
    // If logged in flag switches to false after a successful user login,
    // then redirect to login page.
    if (
      location.pathname != `/staff/forgotpassword` &&
      location.pathname != `/staff/resetpassword`
    )
      redirectToLogin();
  }
}

function redirectToLogin() {
  let pathName = location.pathname;
  let loginUrl = "/staff/login";
  if (pathName.indexOf("login") < 0) {
    if (pathName?.length > 7) {
      loginUrl += "?returnUrl=" + pathName;
    }
    console.log("Staff layout> User is logged out. Redirecting to login page.");
    router.push(loginUrl);
  }
}

const sidebarOpen = ref(false);
const accountDropdownOpen = ref(false);
const notificationDropdownOpen = ref(false);

const counts = computed(() => adminStore.counts);

const notifications = ref<
  { id: string; timestamp: string; message: string; read: boolean }[]
>([
  {
    id: "1",
    timestamp: new Date().toISOString(),
    message: "hello world",
    read: false,
  },
]);

let menuItems = computed(() => {
  let siteCode = bldgStore.siteCode;
  if (!siteCode || siteCode.length === 0) {
    siteCode = "-";
  }

  return [
    {
      sectionName: "Safetynet",
      links: [
        { name: "Portal Settings", to: `/staff/${siteCode}/portal` },
        { name: "Invite Codes", to: `/staff/${siteCode}/invitecodes` },
        { name: "Tenants", to: `/staff/${siteCode}/tenants` },
        { name: "Users", to: `/staff/${siteCode}/users` },
        { name: "Documents", to: `/staff/${siteCode}/documents` },
        { name: "Numbers", to: `/staff/${siteCode}/numbers` },
        { name: "Resource Links", to: `/staff/${siteCode}/links` },
        { name: "Customization", to: `/staff/${siteCode}/customization` },
        { name: "Respond", to: `/staff/${siteCode}/respond` },
        { name: "Roles", to: `/staff/${siteCode}/roles` },
        { name: "User Collections", to: `/staff/${siteCode}/usercollections` },
        { name: "Prepare", to: `/staff/${siteCode}/prepare` },
        { name: "Reports", to: `/staff/${siteCode}/reports` },
        { name: "Portal Metrics", to: `/staff/${siteCode}/portalmetrics` },
        { name: "Client Metrics", to: `/staff/${siteCode}/clientmetrics` },
      ],
    },
    {
      sectionName: "Alert",
      links: [
        { name: "Send Alert", to: `/staff/${siteCode}/alert` },
        { name: "Alert Subscriptions", to: `/staff/${siteCode}/alert/subscriptions` },
        { name: "Alert Templates", to: `/staff/${siteCode}/alert/templates` },
        { name: "Alert History (All)", to: `/staff/alert/history/all` },
      ],
    },
    // {
    //   sectionName: "Activity",
    //   links: [
    //     { name: "Edit Property", to: "/staff/property" },
    //     { name: "Edit Numbers", to: "/staff/Numbers" },
    //     { name: "Edit Videos", to: "/staff/videos" },
    //     { name: "Edit Responses", to: "/staff/responses" },
    //   ],
    // },
    {
      sectionName: "Global Lists",
      links: [
        { name: "Video Library", to: "/staff/videos" },
        { name: "Respond Libraries", to: "/staff/respondlibraries" },
        { name: "Respond Scenarios", to: "/staff/respondscenarios" },
        { name: "Respond Search", to: "/staff/respondsearchresults" },
        { name: "Roles Master", to: "/staff/roleslist" },
        // { name: "Custom Content", to: "/staff/content" },
        { name: "Email Templates", to: "/staff/email" },
        { name: "Clients", to: "/staff/clients" },
        { name: "Bounced Emails", to: "/staff/bouncedemails" },
      ],
    },

    {
      sectionName: "Administration",
      links: [
        { name: "Overview", to: "/staff/overview" },
        {
          name: `Notifications (${counts.value?.staffNotificationsCount ?? 0})`,
          to: "/staff/notifications",
        },
        { name: "Helpers", to: "/staff/helpers" },
        { name: "Bulk Edit", to: "/staff/bulkedit" },
        { name: "Metrics", to: "/staff/metrics" },
        { name: "Client Admin Help", to: "/staff/adminhelp" },
        {
          name: `Link Warnings (${counts.value?.urlWarningsCount ?? 0})`,
          to: "/staff/linkwarnings",
        },
      ],
    },
  ];
});

const props = defineProps({
  section: {
    type: String,
    required: false,
    default: "",
  },
  darkMode: {
    type: Boolean,
    default: false,
  },
  showHeader: {
    type: Boolean,
    default: false,
  },
});
defineEmits(["update:sidebarOpen", "update:darkMode"]);

let handleClickLogout = async function () {
  console.log("logging out");
  await userStore.logStaffUserOff();

  adminStore.setAuthToken("");
  adminStore.staffUserSetupAfterLogin = false;
  alertStore.setAuthToken("");
  bldgStore.setAuthToken("");
  personStore.setAuthToken("");
  respondStore.setAuthToken("");
  trainingStore.setAuthToken("");
  reportStore.setAuthToken("");

  router.push("/staff/login");
};

const version = import.meta.env.VITE_SAFETYNET_VERSION;

const cleanedPath = computed(() => {
  let path = router.currentRoute.value.path
    .replace("/staff/", "/")
    .replace(`/${bldgStore.bldgCode}/`, "/")
    .replace("/-/", "/");

  let elements = path.split("/");
  if (!isNaN(Number(elements[elements.length - 1])))
    path = path.replace("/" + elements[elements.length - 1], "");

  return path;
});
const isStaffNoteOpen = ref(false);
const staffNote = ref({ page: "", note: "" } as StaffNoteDTO);
const isEditingStaffNote = ref(false);
const editedNote = ref("");
const noteSidebarHeight = ref("100vh");

window.addEventListener("scroll", calculateNoteSidebarHeight);

function calculateNoteSidebarHeight() {
  const scrollPosition = window.scrollY;
  const maxScroll = document.documentElement.scrollHeight - window.innerHeight;

  const header = document.querySelector("header");
  const footer = document.querySelector("footer");

  const headerHeight = header ? header.clientHeight : 0;
  const footerHeight = footer ? footer.clientHeight : 0;

  const headerVisibleHeight = Math.max(headerHeight - scrollPosition, 0);
  const footerVisibleHeight = Math.max(footerHeight - (maxScroll - scrollPosition), 0);

  noteSidebarHeight.value = `calc(100vh - ${headerVisibleHeight}px - ${footerVisibleHeight}px)`;
}

const building = computed(() => bldgStore.building);

watch(building, async () => {
  var noteContent = await adminStore.getStaffNote(cleanedPath.value);
  staffNote.value = noteContent;
  //console.log("Staff note loaded:", staffNote.value.note);
});

async function toggleStaffNote() {
  if (isStaffNoteOpen.value) {
    isStaffNoteOpen.value = false;
  } else {
    calculateNoteSidebarHeight();
    staffNote.value = await adminStore.getStaffNote(cleanedPath.value);
    isStaffNoteOpen.value = true;
  }
}

function editStaffNote() {
  editedNote.value = staffNote.value?.note ?? "";
  isEditingStaffNote.value = true;
}

function cancelEditingStaffNote() {
  isEditingStaffNote.value = false;
}

async function saveStaffNote() {
  await adminStore.saveStaffNote({
    page: cleanedPath.value,
    note: editedNote.value,
  } as SaveStaffNoteRequest);
  staffNote.value = await adminStore.getStaffNote(cleanedPath.value);
  isEditingStaffNote.value = false;
}
</script>

<style scoped>
.richText h1 {
  display: block;
  font-size: 2em;
  margin-top: 0.67em;
  margin-bottom: 0.67em;
  margin-left: 0;
  margin-right: 0;
  font-weight: bold;
}
.richText h2 {
  display: block;
  font-size: 1.5em;
  margin-top: 0.83em;
  margin-bottom: 0.83em;
  margin-left: 0;
  margin-right: 0;
  font-weight: bold;
}
.richText h3 {
  display: block;
  font-size: 1.17em;
  margin-top: 1em;
  margin-bottom: 1em;
  margin-left: 0;
  margin-right: 0;
  font-weight: bold;
}
.richText h4 {
  display: block;
  margin-top: 1.33em;
  margin-bottom: 1.33em;
  margin-left: 0;
  margin-right: 0;
  font-weight: bold;
}
.richText h5 {
  display: block;
  font-size: 0.83em;
  margin-top: 1.67em;
  margin-bottom: 1.67em;
  margin-left: 0;
  margin-right: 0;
  font-weight: bold;
}
.richText h6 {
  display: block;
  font-size: 0.67em;
  margin-top: 2.33em;
  margin-bottom: 2.33em;
  margin-left: 0;
  margin-right: 0;
  font-weight: bold;
}

.richText {
  font-size: medium;
}

.richText :deep(a) {
  color: blue;
  text-decoration: underline;
  cursor: pointer;
}

.richText :deep(a:hover) {
  color: cornflowerblue;
}

.richText :deep(ul) {
  padding-left: 24px;
}

.richText :deep(ul > li) {
  font-weight: normal;
  list-style-type: circle !important;
}

.richText :deep(ol) {
  counter-reset: li;
  margin-left: 0;
  padding-left: 0;
}

.richText :deep(ol > li) {
  position: relative;
  margin: 0 0 2px 2em;
  padding: 0 8px;
  list-style: none;
}

.richText :deep(ol > li:before) {
  content: counter(li);
  counter-increment: li;
  position: absolute;
  top: 0px;
  left: -1em;
  box-sizing: border-box;
}

.richText :deep(h2) {
  font-size: x-large;
}

.richText :deep(h3) {
  font-size: larger;
}

.richText :deep(h4) {
  font-size: large;
}
</style>
